<ui-popup-layout>
  <ui-popup-body>
    <div #container class="tw-mt-2">
      <h2 class="tw-font-medium" translate>auth.forgot_password.labels.title</h2>
      <p class="tw-pt-2 tw-pb-3 tw-text-base-text/60" translate>auth.forgot_password.labels.description</p>
      <div class="tw-mb-4">
        <form [formGroup]="form" (ngSubmit)="sendResetLink()">
          <kendo-formfield uiShowErrorAfterBlur class="tw-mb-4">
            <kendo-label
              class="tw-pb-1 tw-text-lg tw-font-bold tw-text-base-text/60 tw-pointer-events-none"
              text="{{ 'auth.shared.labels.email' | translate }}" 
              [for]="email" 
            ></kendo-label>
            <input
              #email kendoTextBox
              autocomplete="off" class="!tw-w-full" formControlName="email"
              placeholder="{{ 'auth.shared.labels.email' | translate }}" required
            />
            <kendo-formerror translate>auth.shared.errors.email</kendo-formerror>
          </kendo-formfield>
          <div class="tw-flex tw-justify-between">
            <div class="tw-flex tw-items-center">
              <a
                class="!tw-text-secondary !tw-font-normal"
                [class.disabled]="loading$ | async"
                (click)="signIn()"
                translate
              >
                auth.forgot_password.actions.sign_in
              </a>
            </div>
            <button kendoButton type="submit" themeColor="secondary" [disabled]="actionDisabled$ | async">
              <span class="tw-flex tw-items-center">
                <span class="tw-mr-2" translate>auth.forgot_password.actions.send_reset_link</span>
                <kendo-loader *ngIf="loading$ | async" class="tw-ml-2" type="pulsing" size="small" [themeColor]="'light'"></kendo-loader>
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </ui-popup-body>
</ui-popup-layout>
